import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/interface-start-icon.gif'


const _hoisted_1 = { class: "relative" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "chat",
  class: "size-18"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatIcon',
  emits: ["interface:open"],
  setup(__props, { emit: __emit }) {


const emits = __emit;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "fixed bottom-0 right-5 z-10 mb-5 rounded-3xl bg-[#f1f1f1] p-2 shadow-lg hover:bg-slate-300 md:right-20",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('interface:open')))
    }, _hoisted_3)
  ]))
}
}

})